import { memo } from 'react'

import { SVGProps } from './types/iconType'

export const ExclamationIcon = memo(({ className, style }: SVGProps) => {
  return (
    <svg className={className} style={style} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <clipPath id="q6b4dfxula">
          <path d="M1920 0v1080H0V0h1920z" />
        </clipPath>
        <clipPath id="cw3n8z80cb">
          <path d="M16.476 0c.318.004.622.129.852.348l6.324 6.324c.22.23.344.534.348.852v8.952a1.26 1.26 0 0 1-.348.852l-6.324 6.324a1.26 1.26 0 0 1-.852.348H7.524a1.26 1.26 0 0 1-.852-.348L.348 17.328A1.26 1.26 0 0 1 0 16.476V7.524a1.26 1.26 0 0 1 .348-.852L6.672.348c.23-.22.534-.344.852-.348zm-.504 2.4H8.028L2.4 8.028v7.944L8.028 21.6h7.944l5.628-5.628V8.028L15.972 2.4zM12 15.6a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4zM12 6a1.2 1.2 0 0 1 1.2 1.2V12a1.2 1.2 0 1 1-2.4 0V7.2A1.2 1.2 0 0 1 12 6z" />
        </clipPath>
      </defs>
      <g clipPath="url(#q6b4dfxula)" transform="translate(-336 -502)">
        <g clipPath="url(#cw3n8z80cb)" transform="translate(336 502)">
          <path d="M0 0h24v24H0V0z" />
        </g>
      </g>
    </svg>
  )
})
